<div
    class="table__overflow"
    *ngIf="timesheets$ | async; else loading">
    <table
        class="table-view"
        *ngIf="timesheets.length > 0; else empty">
        <tr>
            <th>Timesheet</th>
        </tr>
        <tr *ngFor="let timesheet of timesheets">
            <td>
                <app-pill-timesheet
                    [timesheet]="timesheet"
                    [uuid]="timesheet.uuid"></app-pill-timesheet>
            </td>
        </tr>
    </table>
</div>

<ng-template #loading>
    <app-loading-message></app-loading-message>
</ng-template>

<ng-template #empty>
    <app-message-empty
        [title]="'No timesheets...'"
        [subtitle]="'No employee has submitted a timesheet for this project yet.'"
        [icon]="'../../assets/img/open-box.png'">
    </app-message-empty>
</ng-template>
